import { MissionHistory } from '../types/missionHistory';

// Интерфейс для данных игры от API поля
export interface FieldGameData {
  id?: string;
  uniqGameId?: string;
  operationId?: string;
  fieldId?: string;
  fieldName?: string;
  refereeId?: string;
  refereeName?: string;
  teams?: Array<{
    id?: string;
    faction?: string;
    isWin?: boolean;
    playersInTeam?: string;
  }>;
  gameType?: string;
  gameResult?: {
    teamThatWon?: string;
    gameType?: string;
    pointsEarnedForWinners?: number;
    pointsEarnedForLosers?: number;
    gameDuration?: number;
  };
  missionDate?: string;
  isRanked?: boolean;
  notes?: string;
  userIdsList?: string[];
  winnerUserIdsList?: string[];
  loserUserIdsList?: string[];
}

export function adaptFieldGameToMissionHistory(
  fieldGame: FieldGameData,
  fieldNameParam?: string,
  refereeNameParam?: string
): MissionHistory {
  // Используем fieldName из параметра или из данных игры
  const fieldName = fieldNameParam || fieldGame.fieldName || 'Unknown Field';
  const refereeName = refereeNameParam || fieldGame.refereeName || 'Unknown Referee';
  // Используем реальные данные из teams если доступны
  const teams = fieldGame.teams || [];
  const humanTeam = teams.find(team => team.faction?.toLowerCase() === 'human');
  const alienTeam = teams.find(team => team.faction?.toLowerCase() === 'alien');
  
  // Определяем победившую команду
  const winningTeam = teams.find(team => team.isWin === true);
  const teamThatWon = winningTeam?.faction || fieldGame.gameResult?.teamThatWon || '';
  
  // Показываем команду победителей или первую команду если ничья
  let displayFaction = '';
  let result = 'Draw';
  let pointsEarned = 0;
  
  if (teamThatWon) {
    // Показываем победившую команду
    displayFaction = teamThatWon.toLowerCase();
    result = 'Victory';
    pointsEarned = fieldGame.gameResult?.pointsEarnedForWinners || 10;
  } else {
    // Ничья - показываем первую доступную команду  
    displayFaction = humanTeam?.faction || alienTeam?.faction || teams[0]?.faction || 'human';
    result = 'Draw';
    // При ничьей используем очки проигравших или половину от победителей
    pointsEarned = fieldGame.gameResult?.pointsEarnedForLosers || Math.floor((fieldGame.gameResult?.pointsEarnedForWinners || 10) / 2);
  }

  return {
    id: fieldGame.id || fieldGame.uniqGameId || '',
    uniqGameId: fieldGame.uniqGameId || '',
    operationId: fieldGame.operationId || '',
    fieldId: fieldGame.fieldId || '',
    fieldName: fieldName,
    refereeId: fieldGame.refereeId || '',
    refereeName: refereeName,
    gameType: fieldGame.gameType || fieldGame.gameResult?.gameType || 'airsoft',
    missionDate: fieldGame.missionDate || new Date().toISOString(),
    playerFaction: displayFaction.toLowerCase(),
    isPlayerWinner: result === 'Victory',
    result: result,
    pointsEarned: pointsEarned,
    gameDuration: fieldGame.gameResult?.gameDuration || 60,
    notes: fieldGame.notes || '',
    isRanked: fieldGame.isRanked ?? true,
    bonusPoints: 0,
    teamThatWon: teamThatWon
  };
}

export function adaptFieldGamesToMissionHistory(
  fieldGames: FieldGameData[],
  fieldName?: string,
  refereeName?: string
): MissionHistory[] {
  return fieldGames.map(game => adaptFieldGameToMissionHistory(game, fieldName, refereeName));
}